import { FC } from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  LinearProgress,
  SxProps,
} from 'material-hu';

export type AuthCardProps = {
  isLoading?: boolean;
  img?: string;
  title?: string;
  titleVariant?: any;
  isCommunity?: boolean;
  sx?: SxProps;
};

export const AuthCard: FC<React.PropsWithChildren<AuthCardProps>> = (props) => {
  const {
    children,
    isLoading = false,
    img,
    title,
    titleVariant: variant = 'h4',
    isCommunity = false,
    sx = {},
  } = props;

  return (
    <Card
      sx={{
        p: 4,
        width: '100%',
        minHeight: '400px',
        ...sx,
      }}
    >
      {isLoading && (
        <LinearProgress />
      )}
      {img && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Box
            component="img"
            alt=""
            src={img}
            sx={{ maxWidth: '40%' }}
          />
        </Box>
      )}
      {title && (
        <CardHeader
          title={title}
          sx={{
            textAlign: 'center',
            paddingBottom: isCommunity ? '0px' : '',
          }}
          titleTypographyProps={{ variant }}
        />
      )}
      <CardContent
        sx={{
          px: { xs: 2, sm: 4 },
          '&:last-child': {
            pb: 2,
          },
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default AuthCard;
